const sidebard = document.querySelector(".Sidebard")
if (sidebard) {
    lis = sidebard.querySelectorAll(".Sidebard__sidebar ul li"),
        cnts = sidebard.querySelectorAll(".cnt__row");

    window.addEventListener("scroll", () => {

        let already = false;
        let offsetHeight = 0.229185317816 * innerWidth;

        cnts.forEach((cnt, index) => {
            let cntPos = cnt.getBoundingClientRect()
            if (cntPos.top <= innerHeight && cntPos.bottom >= offsetHeight && !already) {
                lis[index].classList.add("crnt")
                already = true
            } else {
                lis[index].classList.remove("crnt")
            }
        })
    })
}

